import { VERIFY_DOCUMENT_REQUEST, VERIFY_DOCUMENT_SUCCESS, VERIFY_DOCUMENT_FAILURE } from '../actions/verify_document'

export const verifyDocument = (
  state = {
    isFetching: false,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case VERIFY_DOCUMENT_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case VERIFY_DOCUMENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    case VERIFY_DOCUMENT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
